export default {
  title: 'Push-notifikationer',
  description: 'Send målrettede push-notifikationer til dine kunder',
  buttons: {
    new_campaign: 'Ny kampagne',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Mobilappen er ikke live endnu',
      description: 'Vent venligst, til mobilappen er live, før du kan sende push-notifikationer',
    },
  },
};
